import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import { faPlus, faXmark, faCircle, faPaperclip, faCircleXmark, faBolt, faEllipsis, faLink, faCircleCheck, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { MultiSelect } from 'react-multi-select-component';
import Dropdown from 'react-bootstrap/Dropdown';
import Docmnt from '../../../assets/images/google-docs.png';
import Select from 'react-select';
import Export from "../../../assets/images/export.svg";
import edit from "../../../assets/images/edit.png";
import Cargoplane from "../../../assets/images/plane.svg";
import Cuser from "../../../assets/images/cuser.png";
import Trash from '../../../assets/images/trash.png';
import Return from '../../../assets/images/return.png';
import Badge from 'react-bootstrap/Badge';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { ULDREPAIRGRID, GETULDDETAILS, MSGGRID, MSGPROCESSMVT, ULDADDRESSSAVE } from '../../../Utils/conts.js';
import { jqxCookieCall } from '../../../Components/common/CommonFunctions.js';


const Messages = ({ }) => {

    const isMounted = useRef(false);
    const [isLoading, setIsLoading] = useState(true);
    const [openCount, setOpenCount] = useState({});
    const [processCount, setProcessCount] = useState({});
    const [trashCount, setTrashCount] = useState({});
    const [allData, setAllData] = useState([]);
    const [gridData, setGridData] = useState({
        Open: [],
        Processed: [],
        Trash: [],

    });
    const [filterApplied, setFilterApplied] = useState(false);

    useEffect(() => {
        if (isMounted.current) return;
        // Call the fetchData function to fetch data from the API
        // fetchDataGrid();
        setIsLoading(false);
        setGridData({ Open: [] });
        isMounted.current = true;
    }, []);

    const [selectedRowData, setSelectedRowData] = useState(null);
    const [gridSelect, setGridSelect] = useState([]);
    const [activeTab, setActiveTab] = useState('Open');
    const gridRefs = {
        Open: useRef(null),
        Processed: useRef(null),
        Trash: useRef(null),
    };
    const handleTabChange = async (tab) => {
        setActiveTab(tab);
        setIsLoading(true);
        setFilterApplied(false);
        if (selectedRowData) {
            setSelectedRowData(null)
        }
        if (gridSelect) {
            setGridSelect([])
        }
        if (tab == 'Open') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Open: [] });
            }, 1);
        } else if (tab == 'Processed') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Processed: [] });
            }, 1);
        } else {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Trash: [] });
            }, 1);
        }
    };

    const [confModal, setConfModal] = useState(false);
    const [moveInfo, setMoveInfo] = useState([]);

    const confModalClose = () => {
        setConfModal(false);
        setMoveInfo([]);
    }
    const handleRemove = () => {
        if (gridSelect.length > 0) {
            const ids = gridSelect?.map(inid => inid.email_inbox_id);
            setMoveInfo(ids);
            setConfModal(true);
        } else {
            toast.error('Please select at least one message');
        }
    }

    const confirmMove = async () => {
        const dataToSend = {
            email_inbox_id: moveInfo,
            action: activeTab !== 'Trash' ? '0' : '1'
        }
        // console.log("🚀 ~ confirmMove ~ dataToSend:", dataToSend)
        
        // console.log("🚀 ~ setGridSelect ~ setGridSelect:", gridSelect)
        try {
            const res = await withRFSToken.post('messages/move-active-archive', dataToSend)
                .then(function (res) {
                    // const innerData = res;
                    // console.log("🚀 ~ .then ~ innerData:", innerData)
                    if (res.data.response_code == 200) {
                        toast.success('Moved Successfully');
                        setConfModal(false);
                        setMoveInfo([])
                        setTimeout(() => {
                            setIsLoading(false);
                            // setGridData({})
                            window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                        }, 1);
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                        setGridSelect([])
                    } else {
                        toast.error(res.data.response_msg);
                    }
                });

        } catch (error) {
            console.error('Error sending request:', error);
        }
    }

    const [highlightedRowBoundIndex, setHighlightedRowBoundIndex] = useState(null);
    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {

        if (gridRefs[activeTab]?.current) {
            // if (gridData[activeTab]) {
            // var token = "Bearer " + localStorage.ULD;
           jqxCookieCall()
            let tabType = '';
            if (activeTab == 'Open') { tabType = 'O' } else if (activeTab == 'Processed') { tabType = 'P' } else if (activeTab == 'Trash') { tabType = 'T' }
            const source = {
                datatype: 'json',
                id: '',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'message_type', type: 'string' },
                    { name: 'movement_type', type: 'string' },
                    { name: 'message_status', type: 'string' },
                    { name: 'message_processing_status', type: 'string' },
                    { name: 'sender_email', type: 'string' },
                    { name: 'received_date_time', type: 'date' },
                    { name: 'message_data', type: 'string' },
                    { name: 'email_inbox_id', type: 'string' },
                    { name: 'owner_code', type: 'string' },
                    { name: 'agent_name', type: 'string' },
                    { name: 'station', type: 'string' },
                    { name: 'flight_number', type: 'string' },
                    { name: 'auto_process_message', type: 'string' },
                    { name: 'processed_by', type: 'string' },
                    { name: 'deleted_by', type: 'string' },

                ],
                // localdata: gridData[activeTab],
                id: `${activeTab}-`,
                url: `${process.env.REACT_APP_RFS_URL}${MSGGRID}?type=${tabType}`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },

                // pagesize: 50,
                filter: function (allfilters) {
                    // window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
                    // setGridSelect([]);

                    // if (allfilters.length > 0) {
                    //     console.log("Filter Applied");
                    //     setFilterApplied(true);
                    // } else {
                    //     console.log("Filter Cleared");
                    //     setFilterApplied(false);
                    // }
                    // window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");


                    setTimeout(() => {
                        const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');

                        console.log("rows", rows);
                        (checkUlds).forEach(uldNumber => {
                            console.log('chk', checkUlds);
                            rows.forEach((element, index) => {
                                if (element.uld_number == uldNumber) {
                                    window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
                                }
                            });
                        });
                    }, 4000);
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.total_data; // activeTab == 'Open' ? data.open_messages : (activeTab == 'Processed' ? data.processed_messages : data.trash_messages);
                    let openMsg = 0;
                    let prsdMsg = 0;
                    let trshdMsg = 0;
                    if (data) {
                        openMsg = data.open_messages;
                        prsdMsg = data.processed_messages;
                        trshdMsg = data.trash_messages;
                    }
                    data.Rows = data.Rows.map(row => ({ ...row, selected: false }));
                    setAllData(data.Rows);
                    setOpenCount({ totalUlds: openMsg });
                    // onNumberUpdate(repairCount);
                    setProcessCount({ totalUlds: prsdMsg });
                    setTrashCount({ totalUlds: trshdMsg });
                },
                sort: function () {
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };

            const dataAdapter = new window.$.jqx.dataAdapter(source);
            // console.log('localdata', source.localdata)

            const columns = [
                // { text: 'id', filtertype: 'textbox', datafield: 'id', width: '40%' },
                // {
                //     text: '', datafield: 'selected', columntype: 'checkbox', width: 40,
                //     threestatecheckbox: false,  // optional
                //     editable: true,
                //     cellvaluechanging: (row, datafield, columntype, oldvalue, newvalue) => {
                //         const rowData = window.$(gridRefs[activeTab]?.current).jqxGrid('getrowdata', row);

                //         if (newvalue) {
                //           setGridSelect((prev) => {
                //             const alreadyExists = prev.some(r => r.id === rowData.id);
                //             if (!alreadyExists) return [...prev, rowData];
                //             return prev;
                //           });
                //         } else {
                //           setGridSelect((prev) => prev.filter(r => r.id !== rowData.id));
                //         }

                //         return true; 
                //       }
                //   },
                ...( // Add this column only if the condition is met
                    activeTab !== 'Trash'
                        ? [{
                            text: 'Actions',
                            cellsrenderer: function () {
                                return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /><img src="' + Trash + '" class="row_trash" /></div>';
                            },
                            width: '6%', filterable: false,
                        }]
                        : []
                ),

                { text: 'Movement Type', filtertype: 'textbox', datafield: 'movement_type', width: '8%', cellclassname: '', },
                {
                    text: 'Process', filterable: false, datafield: 'type_code', width: '8%', cellclassname: '',
                    cellsrenderer: function () {
                        return '<div class="grid_actions row_process"><img src="' + Return + '" class="" /> Process</div>'; //<img src="'+edit+'" class="row_edit" />
                    }
                },
                {
                    text: 'Status', filtertype: 'textbox', datafield: 'message_processing_status', width: '8%', cellclassname: '',

                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        if (rowdata.message_processing_status === 'Processed') {
                            return '<div class="grid_actions row_proced"> Processed </div>';
                        } else {
                            return '<div class="grid_actions row_open"> Open </div>';
                        }
                    }
                },
                {
                    text: 'Received On', filtertype: 'range', cellsformat: 'dd-MM-yyyy', filtermode: 'range', datafield: 'received_date_time',
                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        if (!cellValue) return "";
                        const dateObj = new Date(cellValue + "Z");
                        const formattedDate = dateObj.toISOString().slice(0, 16).replace("T", " ");
                        return '<div class="set_datetime" id=' + dataField + '>' + formattedDate + '</div>';
                    },
                    width: '9%', cellclassname: '',
                },

                { text: 'Received From', filtertype: 'textbox', datafield: 'sender_email', width: '15%', cellclassname: '', },
                { text: 'Owner Code', filtertype: 'textbox', datafield: 'owner_code', width: '8%', cellclassname: '', },
                { text: 'Station', filtertype: 'textbox', datafield: 'station', width: '8%', cellclassname: '', },
                { text: 'Flight No', filtertype: 'textbox', datafield: 'flight_number', width: '8%', cellclassname: '', },
                { text: 'Agent Name', filtertype: 'textbox', datafield: 'agent_name', width: '8%', cellclassname: '', },
                activeTab == 'Open' ? { text: 'Processing Issue', filtertype: 'textbox', datafield: 'auto_process_message', width: '18%', cellclassname: '', }
                    : { text: 'Processed By', filtertype: 'textbox', datafield: 'processed_by', width: '10%', cellclassname: '', },
                ...(
                    activeTab == 'Trash'
                        ? [{ text: 'Deleted By', filtertype: 'textbox', datafield: 'deleted_by', width: '10%', cellclassname: '', },]
                        : []
                ),



            ];

            // const gridOptions = {
            //     width: '100%',
            //     source: dataAdapter,
            //     columns: columns,
            //     autoheight: false,
            //     height: 1040,
            //     sortable: true,
            //     altrows: false,
            //     enabletooltips: true,
            //     editable: false,
            //     selectionmode: 'checkbox',
            //     pageable: true,
            //     pageSize: 50,
            //     pagesizeoptions: ['50', '100', '200', '500'],
            //     pagerButtonsCount: 5,
            //     pagerMode: 'advanced',
            //     filterable: true,
            //     filterrowheight: 45,
            //     showfilterrow: true,
            //     rowsheight: 42,
            //     columnsheight: 45,
            //     virtualmode: true,
            //     rendergridrows: function (params) {
            //         return params.data;
            //     },
            // };
            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                selectionmode: 'checkbox',
                pageable: true,
                pageSize: 50,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
                rendered: function () {
                    const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                    // { console.log("🚀 ~ useEffect ~ rows:", rows) }
                    (checkUlds).forEach(uldNumber => {
                        rows.forEach((element, index) => {
                            if (element.email_inbox_id == uldNumber) {
                                window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
                            }
                        });
                    });
                }
            };

            window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
            window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');
            window.$(gridRefs[activeTab].current).on('click', '.row_edit', function () {
                // console.log("🚀 ~ event:01010", event)
                const rowDiv = window.$(this).closest('[role="row"]');
                // const cellDiv = this.id;
                // console.log("🚀 ~ cellDiv:", rowDiv)
                const rowIndex = window.$(rowDiv).attr('row-id');
                const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);

                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                    // console.log('Global Index:', globalIndex); 
                    const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
                    if (rowData) {
                        // console.log('Row Data:', rowData);
                        setEditFormData({ email_inbox_id: rowData.email_inbox_id });
                        setModalShow(true);
                    } else {
                        console.error('No data found for the given row index.');
                    }
                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }
            });
            window.$(gridRefs[activeTab].current).on('click', '.row_trash', function () {
                // console.log("🚀 ~ event:01010", event)
                const rowDiv = window.$(this).closest('[role="row"]');
                // const cellDiv = this.id;
                // console.log("🚀 ~ cellDiv:", rowDiv)
                const rowIndex = window.$(rowDiv).attr('row-id');
                const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);

                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                    // console.log('Global Index:', globalIndex); 
                    const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
                    if (rowData) {
                        // console.log('Row Data:', rowData);
                        setMoveInfo([rowData.email_inbox_id]);
                        setConfModal(true);
                    } else {
                        console.error('No data found for the given row index.');
                    }
                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }
                // const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
                // console.log('rowData', rowData);

                // const dataToSend = {
                //     uld_number: rowData.uld_number,
                //     type_code: rowData.type_code,
                //     serial_number: rowData.serial_number,
                //     owner_code: rowData.owner_code,
                //     condition_code: rowData.condition_code,
                //     asset_type: rowData.asset_type == 'Y' ? false : true
                // };
                // setEditData(dataToSend);

                // handleMovement()

            });
            window.$(gridRefs[activeTab].current).on('click', '.row_process', function (event) {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                // console.log('rowIndex', rowIndex);
                const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);

                if (boundIndex !== undefined) {
                    // Fetch the row data using the bound index
                    // const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', boundIndex);
                    const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum; // Current page number (zero-based)
                    const pageSize = pagingInfo.pagesize; // Number of rows per page
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize; // Adjusted index for the entire data source

                    console.log('Global Index:', globalIndex); // Debug global index

                    // Fetch row data using the global index
                    const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);

                    if (rowData) {
                        // console.log('Row Data:', rowData);

                        // Call your processing function with the retrieved row data
                        if (rowData.movement_type == 'NA') {
                            toast.error('Movement type is unknown, please indicate movement type.')
                        } else {
                            handleProcessButtonClick(rowData.movement_type, rowData.message_data, rowData.email_inbox_id);
                        }

                    } else {
                        console.error('No data found for the given row index.');
                    }
                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }
                // const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);

                // handleProcessButtonClick(rowData.movement_type, rowData.message_data, rowData.email_inbox_id);
            });

            window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            // row selection by checkbox
            window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
                // console.log("🚀 ~ window.$ ~ event:00000000", event.args.row)
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const selectedRowId = selectedRow.uid;
                    const uldNumber = selectedRow.email_inbox_id;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    // if (!gridSelect.some(row => row.uid === selectedRowId)) {
                    //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                    // }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.email_inbox_id === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.email_inbox_id;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.email_inbox_id !== unselectedRowId));
                    // if(filterForCheck!=true){
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                    // }
                    // console.log(checkUlds);

                }
            });

            // window.$(gridRefs[activeTab].current).on('rowclick', function (event) {
            //     const rowIndex = event.args.rowindex;
            //     const isSelected = window.$(gridRefs[activeTab].current).jqxGrid('isrowselected', rowIndex);

            //     if (isSelected) {
            //       window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', rowIndex);
            //     } else {
            //       window.$(gridRefs[activeTab].current).jqxGrid('selectrow', rowIndex);
            //     }
            //   });
            // End row selection 
        }

        window.$(gridRefs[activeTab].current).off('cellclick');
        window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
            const args = event.args.row.bounddata;
            // console.log('event', event);
            const rowIndex = event.args.rowindex;
            const boundIndex = event.args.row.boundindex;
            // console.log("🚀 ~ window.$ ~ boundIndex:", event.args.row)
            // window.$(gridRefs[activeTab].current).find("[role='row']").removeClass('highlighted-row');
            // console.log('rowIndex', window.$(gridRefs[activeTab].current).jqxGrid('getrowboundindex', rowIndex));

            if (event.args.columnindex !== 1 && event.args.columnindex !== 3 && event.args.columnindex !== 4) {
                if (gridSelect) {
                    gridSelect.forEach(item => {
                        const selectedRowBoundIndex = item.boundindex;
                        window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                    });
                    // setGridSelect([]);
                }



                // window.$(gridRefs[activeTab].current).jqxGrid('getrowboundindex', rowIndex);
                // window.$(gridRefs[activeTab].current).find(`[row-id='${rowIndex}']`).addClass('highlighted-row');
                setHighlightedRowBoundIndex(boundIndex);
                // const messageWithLineBreaks = args.message_data.replace(/\n/g, "<br />");
                // console.log('args', messageWithLineBreaks);
                setSelectedRowData(args.message_data);
                // loadDetails(args.uld_number);
                setTimeout(() => {
                    window.$(gridRefs[activeTab].current).jqxGrid('refresh');
                }, 300);
            }
        });
    }, [gridData]);

    useEffect(() => {
        if (highlightedRowBoundIndex !== null) {
            setTimeout(() => {
                const rows = window.$(gridRefs[activeTab].current).find("[role='row']");





                rows.each(function () {
                    // const rowId = window.$(this).attr('data-id'); // or whatever identifies the bound index
                    const visibleRow = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', window.$(this).index());
                    console.log("🚀 ~ visibleRow:", visibleRow)
                    console.log("🚀 ~ window.$(this).index():", window.$(this).index())

                    if (window.$(this).index() === visibleRow.boundindex) {
                        console.log('window.$(this)', window.$(this));

                        window.$(this).find('.jqx-grid-cell').addClass('highlighted-cell');
                    }

                    if (visibleRow.boundindex === highlightedRowBoundIndex) {
                        console.log("🚀 ~ visibleRow:", visibleRow.email_inbox_id)
                        console.log("🚀 ~ highlightedRowBoundIndex:", window.$(this))
                        window.$(this).addClass('highlighted-row');
                        window.$(this)[0].cells.forEach(function (event) {
                            console.log('event log', event);
                            // event.addClass('highlighted-row')

                            // event = event.replace('jqx-grid-cell', 'jqx-grid-cell xyz');
                            // console.log(event);
                        });
                    } else {
                        window.$(this).removeClass('highlighted-row');
                    }
                });
            }, 100); // wait for DOM to render
        }
    }, [highlightedRowBoundIndex, activeTab]);


    const handleProcessButtonClick = async (msgFor, msgData, inboxid) => {
        const matchingRowData = allData.find((row) => row.email_inbox_id === inboxid);
        console.log('allData', allData);
        console.log('matchingRowData', matchingRowData);

        // setIsLoading(true);
        const keysToRemove = [
            'Repair In', 'Repair Out', 'SCM', 'Lease Out', 'UCM Out',
            'UCM In', 'LUC In', 'LUC Out', 'Transfer', 'Request'
        ];

        // Remove keys from localStorage
        keysToRemove.forEach(key => localStorage.removeItem(key));
        // Process the data in processText
        let keyTypeMapping;
        // if (!keyType == 'UCM Out'){
        keyTypeMapping = {
            'LEASE OUT': 'LEO',
            'SCM': 'SCM',
            'UCM OUT': 'UO',
            'FFM': 'FFM',
            'CPM': 'CPM',
            'UCM IN': 'UI',
            'LUC IN': 'LI',
            'LUC OUT': 'LO',
        };
        // } else {
        let keyType;
        if (msgFor == 'LEASE OUT') {
            keyType = 'Lease Out'
        } else if (msgFor == 'SCM') {
            keyType = 'SCM'
        } else if (['UCM OUT', 'FFM', 'CPM'].includes(msgFor)) {
            keyType = 'UCM Out'
        } else if (msgFor == 'UCM IN') {
            keyType = 'UCM In'
        } else if (msgFor == 'LUC IN') {
            keyType = 'LUC In'
        } else if (msgFor == 'LUC OUT') {
            keyType = 'LUC Out'
        }
        // keyTypeMappingUO = msgFor == 'ucm_out' ? 'UO' : msgFor == 'ffm' ? 'FFM' : 'CPM';
        // }

        // const actiontype = keyType !== 'UCM Out' ? keyTypeMapping[keyType] : keyTypeMappingUO;
        // const msgType = msgFor == 'ucm_out' ? ucmOutText : msgFor == 'ffm' ? ffmText : msgFor == 'cpm' ? cpmText : processText;

        const localStorageKey = keyType;
        const existingData = JSON.parse(localStorage.getItem(localStorageKey)) || [];
        const updatedData = {
            // ...existingData,
            Form: {},
            ULD: [],
            email_inbox_id: inboxid,
            message: msgData,
            msgtype: msgFor
        };
        localStorage.setItem(localStorageKey, JSON.stringify(updatedData));
        window.location.href = '/ULDControl/ULDFunction';

        // try {
        //     const res = await withRFSToken.post(MSGPROCESSMVT, { message_type: keyTypeMapping[msgFor], message: msgData });
        //     if (res.data.response_code == 200) {
        //         // toast.success('Message processed');
        //         // setFormData(res.data.response_data);
        //         const responseData = res.data.response_data;
        //         const updatedForm = {
        //             ...responseData.Form, // Spread existing form data
        //             flight_or_truck: responseData.Form.flight_or_truck || 'F' // Add or retain flight_or_truck
        //         };
        //         console.log('100', res.data.response_data);
        //         const localStorageKey = keyType;
        //         const existingData = JSON.parse(localStorage.getItem(localStorageKey)) || [];
        //         const updatedData = {
        //             // ...existingData,
        //             Form: updatedForm,
        //             ULD: responseData.uldInfo,
        //             email_inbox_id: inboxid,
        //             message: msgData,
        //             msgtype: msgFor
        //         };
        //         localStorage.setItem(localStorageKey, JSON.stringify(updatedData));
        //         // const event = new Event('localStorageUpdated');
        //         // window.dispatchEvent(event);
        //         setIsLoading(false);
        //         window.location.href = '/ULDControl/ULDFunction';
        //     } else {
        //         toast.error(res.data.response_msg);
        //     }
        //     // .then(function (res) {

        //     // });

        // } catch (error) {
        //     console.error('Error fetching data:', error);
        // }
    };
    const loadDetails = async (uldNumber) => {
        try {
            const res = await withRFSToken.post(GETULDDETAILS, { uld_number: uldNumber })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // console.log("🚀 ~ .then ~ innerData:654", innerData)
                    setSelectedRowData(innerData);

                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const [modalShow, setModalShow] = useState(false);
    const [editFormData, setEditFormData] = useState({});
    const movementOPtion = [
        { label: 'UCM In', value: 'UCM_IN' },
        { label: 'UCM Out', value: 'UCM_OUT' },
        { label: 'LUC In', value: 'LUC_IN' },
        { label: 'LUC Out', value: 'LUC_OUT' },
        { label: 'SCM', value: 'SCM' },
        { label: 'FFM', value: 'FFM' },
        { label: 'CPM', value: 'CPM' },
    ];

    const handleEditSave = async () => {
        // const dataToSend = { ...editFormData };
        // console.log("🚀 ~ handleEditSave ~ dataToSend:", dataToSend)
        try {
            const res = await withRFSToken.post('messages/update-movement-type', editFormData)
                .then(function (res) {
                    if (res.data.response_code == 200) {
                        toast.success(res.data.response_msg)
                        setTimeout(() => {
                            setIsLoading(false);
                            window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                        }, 1);
                        handleModalClose();
                    } else {
                        toast.error(res.data.response_msg);
                    }
                });

        } catch (error) {
            console.error('Error sending request:', error);
        }
    }
    const handleModalClose = () => {
        setModalShow(false);
        setEditFormData({});
    };

    const handleCloseClick = () => {
        setSelectedRowData(null);
        setTimeout(() => {
            window.$(gridRefs[activeTab].current).jqxGrid('refresh');
            window.$(gridRefs[activeTab].current).find("[role='row']").removeClass('highlighted-row');
        }, 300);
    };
    const resetFilters = () => {
        window.$(gridRefs[activeTab].current).jqxGrid('clearfilters');
        gridSelect.forEach(item => {
            const selectedRowBoundIndex = item.boundindex;
            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
        });
    };

    return (
        <>
            {/* {console.log('highlightedRowBoundIndex', highlightedRowBoundIndex)} */}
            {/* {console.log("🚀 ~ Select:", gridSelect)} */}
            <div className="mb-3 nestedtabs rounded minh">
                <div className='d-flex'>


                </div>
            </div>
            {activeTab !== 'Trash' &&
                <div className='ulddown'>
                    <button onClick={handleRemove}><img src={Trash} /> Delete</button>
                </div>
            }

            <div className="maindiv">
                <div className="trashdonload">
                    <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
                        <Tab eventKey="Open" title={<span>Open <Badge className='rabadge'>{openCount.totalUlds}</Badge></span>} className='moveto'>
                            {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                            {!isLoading && <div ref={gridRefs.Open} className='bookinggrid' ></div>}
                        </Tab>
                        <Tab eventKey="Processed" title={<span>Processed <Badge className='rabadge'>{processCount.totalUlds}</Badge></span>} className='moveto'>
                            {/* <div className='ulddown'>
                                <button onClick={exportToExcel}><img src={Export} /> Download</button>
                            </div> */}
                            {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                            {!isLoading && <div ref={gridRefs.Processed} className='bookinggrid' ></div>}
                        </Tab>

                        <Tab eventKey="Trash" title={<span>Trash <Badge className='rabadge'>{trashCount.totalUlds}</Badge></span>} className='moveto'>
                            {/* <div className='ulddown'>
                                <button onClick={exportToExcel}><img src={Export} /> Download</button>
                            </div> */}
                            {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                            {!isLoading && <div ref={gridRefs.Trash} className='bookinggrid' ></div>}
                        </Tab>
                    </Tabs>
                </div>
                {selectedRowData && (
                    <div className="SecondDiv mt-45 uld_msg">
                        {/* {console.log('55', selectedRowData)} */}
                        <button className="close" onClick={handleCloseClick}>
                            {" "}
                            <FontAwesomeIcon icon={faXmark} />{" "}
                        </button>
                        <div className="girddtals_header">
                            <h3>Message</h3>
                        </div>
                        <div>
                            {/* <p dangerouslySetInnerHTML={{ __html: selectedRowData }}></p> */}
                            <p style={{ whiteSpace: 'pre-line' }}>{selectedRowData}</p>
                        </div>
                    </div>
                )}
            </div>
            <Modal show={confModal} onHide={confModalClose} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3>This will move to Trash</h3>
                    <p>Are you sure you want to move trash?</p>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={confModalClose}>
                            No
                        </Button>
                        <Button variant="primary" onClick={confirmMove}>
                            Yes
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal show={modalShow} onHide={handleModalClose} className='addfrom change_type editculm' centered>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Movement </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm='12' className='mb-2'>
                            <Form.Label className='form-label'>Movement Type</Form.Label>
                            <Select
                                options={movementOPtion}
                                onChange={(selected) => {
                                    const updatedData = { ...editFormData, movement_type: selected.value };
                                    setEditFormData(updatedData);
                                }}
                                placeholder="Movement Type"
                                className='autoslct'
                                name="movement_type"
                                value={movementOPtion.find(option => option.value === editFormData.movement_type)}
                            />
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="primary" onClick={handleEditSave}>
                            Update Movement
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default Messages;